'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  fullWidth: _propTypes2.default.bool,
  dense: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  bordered: _propTypes2.default.bool,
  colorScheme: _propTypes2.default.oneOf(['neutral', 'error', 'success']),
  /**
   * Define theme
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  fullWidth: false,
  dense: false,
  disabled: false,
  focused: false,
  bordered: false,
  colorScheme: 'neutral'
};

/** Prop Receivers */
var sizeProps = function sizeProps(_ref) {
  var fullWidth = _ref.fullWidth,
      themeFromProvider = _ref.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var minWidth = theme.reactackle.components.selectBox.selectBox.minWidth;


  var sizeDependentStyles = null;
  if (fullWidth) {
    sizeDependentStyles = '\n      display: flex;\n      align-items: center;\n    ';
  }

  return (0, _styledComponents.css)(['min-width:', ';', ''], (0, _reactackleCore.getValueString)(minWidth), sizeDependentStyles);
};

var styleProps = function styleProps(_ref2) {
  var disabled = _ref2.disabled,
      focused = _ref2.focused,
      colorScheme = _ref2.colorScheme,
      themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = theme.reactackle.components.selectBox.selectBox.style;

  if (disabled) {
    return '\n      cursor: default;\n      user-select: none;\n      \n      &,\n      &:hover,\n      &:focus {\n        background-color: ' + source.disabled.backgroundColor + ';\n        color: ' + source.disabled.fontColor + ';\n        border-color: ' + source.disabled.borderColor + ';\n        border-style: ' + source.disabled.borderStyle + ';\n        outline: none;\n      }\n    ';
  }

  if (colorScheme === 'neutral') {
    if (focused) {
      return '\n        outline: none;\n        cursor: pointer; \n        background-color: ' + source.focus.backgroundColor + ';\n        color: ' + source.focus.fontColor + ';\n        border-color: ' + source.focus.borderColor + ';\n        border-style: ' + source.focus.borderStyle + ';\n      ';
    }

    return (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';cursor:pointer;&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source.backgroundColor, source.fontColor, source.borderColor, source.borderStyle, source.hover.backgroundColor, source.hover.fontColor, source.hover.borderColor, source.hover.borderStyle);
  }

  return (0, _styledComponents.css)(['background-color:', ';color:', ';border-color:', ';border-style:', ';cursor:pointer;&:hover{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}&:focus{outline:none;background-color:', ';color:', ';border-color:', ';border-style:', ';}'], source[colorScheme].backgroundColor, source[colorScheme].fontColor, source[colorScheme].borderColor, source[colorScheme].borderStyle, source[colorScheme].hover.backgroundColor, source[colorScheme].hover.fontColor, source[colorScheme].hover.borderColor, source[colorScheme].hover.borderStyle, source[colorScheme].hover.backgroundColor, source[colorScheme].hover.fontColor, source[colorScheme].hover.borderColor, source[colorScheme].hover.borderStyle);
};

var borderProps = function borderProps(_ref3) {
  var bordered = _ref3.bordered,
      fullWidth = _ref3.fullWidth,
      themeFromProvider = _ref3.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = bordered ? theme.reactackle.components.selectBox.selectBox.bordered : theme.reactackle.components.selectBox.selectBox.underlined;

  var borderWidth = source.borderWidth,
      borderRadius = source.borderRadius;


  return bordered ? (0, _styledComponents.css)(['border-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius)) : (0, _styledComponents.css)(['border-width:0;border-bottom-width:', ';border-radius:', ';'], fullWidth ? '0' : (0, _reactackleCore.getValueString)(borderWidth), (0, _reactackleCore.getValueString)(borderRadius));
};

/** Styles */
var ButtonStyled = exports.ButtonStyled = _styledComponents2.default.button.withConfig({
  displayName: 'ButtonStyled'
})(['display:flex;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;flex-grow:1;user-select:none;max-width:100%;position:relative;align-items:center;text-align:left;padding:0;', ' ', ' ', ' ', ' &:focus{outline:none;}'], sizeProps, styleProps, borderProps, (0, _reactackleCore.transition)('color, background, border'));

ButtonStyled.propTypes = propTypes;
ButtonStyled.defaultProps = defaultProps;
ButtonStyled.displayName = 'ButtonStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/SelectBoxCustom/styles/ButtonStyled.js
// module id = 791
// module chunks = 0